import { render, staticRenderFns } from "./YearList.vue?vue&type=template&id=06ba1cd3&scoped=true&"
import script from "./YearList.vue?vue&type=script&lang=js&"
export * from "./YearList.vue?vue&type=script&lang=js&"
import style0 from "./YearList.vue?vue&type=style&index=0&id=06ba1cd3&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06ba1cd3",
  null
  
)

export default component.exports